import { render, staticRenderFns } from "./vuetify-phone-number-input.vue?vue&type=template&id=6c76cdd4&"
import script from "./vuetify-phone-number-input.vue?vue&type=script&lang=js&"
export * from "./vuetify-phone-number-input.vue?vue&type=script&lang=js&"
import style0 from "./sprite.css?vue&type=style&index=0&lang=css&"
import style1 from "./vuetify-phone-number-input.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
